webpackJsonp([167960200349485],{

/***/ 433:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/src/pages/suny.md absPath of file >>> MarkdownRemark","html":"<p>Suny</p>","fields":{"slug":"/suny/"},"frontmatter":{"date":"April 09, 2018","title":"SUNY","cover":"/img/coffee-gear.png","meta_title":"SUNY","meta_description":"SUNY","username":"suny","tags":["SUNY"]}}},"pathContext":{"id":"/opt/build/repo/src/pages/suny.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---suny-9cbf518376c81a189903.js